export function downloadZipFlow (flow) {
  let blob = flow
  const fileName = 'download_data.zip'
  let downloadElement = document.createElement('a')
  let binaryData = []
  binaryData.push(blob)
  let href = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/zip' }))
  downloadElement.href = href
  downloadElement.download = decodeURIComponent(fileName)
  document.body.appendChild(downloadElement)
  downloadElement.click()
  document.body.removeChild(downloadElement)
  window.URL.revokeObjectURL(href)
}